import OrgSettingsSidebar from './OrgSettingsSidebar';

export default OrgSettingsSidebar;
